// Modules
import React from 'react';
import { Element } from 'react-scroll';
import cx from 'classnames';
// Components
import OMInputWithLable from '../OMComponents/OMInputWithLable/OMInputWithLable';
import OMButtonWithPreloader from '../OMComponents/OMButtonWithPreloader/OMButtonWithPreloader';
import CloudflareCaptcha from '../CloudflareCaptcha/CloudflareCaptcha';
// Helpers
import { contactUsUsage } from '../../constants';
import CAPTCHA_ACTIONS from '../../helpers/captchaConstants';
// Styles
import * as styles from './ContactUsForm.scss';

const bottomBlock = (properties) => {
  const isRealtor = properties.usage === contactUsUsage.agent || properties.usage === contactUsUsage.realtorPackages;

  return (
    <div className={cx(
      styles.bottomBlock,
      { [styles.projectsContactUsForm]: properties.usage === contactUsUsage.projects },
      { [styles.realtorPackagesContactUsForm]: properties.usage === contactUsUsage.realtorPackages }
    )}
    >
      <div className={styles.bottomContent}>
        <CloudflareCaptcha
          action={isRealtor ? CAPTCHA_ACTIONS.CONTACT_US_REALTOR : CAPTCHA_ACTIONS.CONTACT_US}
          fetchToken={properties.fetchReCaptchaToken}
          doReset={properties.error}
        />
        <OMButtonWithPreloader
          showPreloader={properties.showPreloader}
          onClick={properties.onSubmit}
          className="contactUsForm"
          innerText={properties.translate('submitButton')}
        />
        <div className={styles.requiredTitle}>
          {properties.translate('requiredField')} - <span className="required">*</span>
        </div>
      </div>
    </div>
  );
};

const MessageSection = properties => (
  (properties.usage === contactUsUsage.agent || properties.usage === contactUsUsage.realtorPackages)
  ? (<div className={styles.agentBottomBlock}>{bottomBlock(properties)}</div>)
  : (
    <div className={styles.contentBlock}>
      <Element name="subject" className={styles.contentRow}>
        <OMInputWithLable
          title={`${properties.translate('subjectTitle')}`}
          name="subject"
          placeholder={`${properties.translate('subjectPlaceholder')}`}
          field={{
            onChange: properties.handleChange,
            validate: value => !!value,
            isInvalid: properties.fieldIsInvalid('subject')
          }}
          className={(properties.usage === contactUsUsage.projects) ? 'projectsContactUsForm' : 'contactUsForm'}
          required
          isRtl={properties.isRtl}
        />
      </Element>
      <Element name="message" className={styles.contentRow}>
        <OMInputWithLable
          title={`${properties.translate('messageTitle')}`}
          name="message"
          type="textarea"
          placeholder={`${properties.translate('messagePlaceholder')}`}
          field={{
            onChange: properties.handleChange,
            validate: value => !!value,
            isInvalid: properties.fieldIsInvalid('message')
          }}
          className={(properties.usage === contactUsUsage.projects) ? 'projectsContactUsForm' : 'contactUsForm'}
          required
          isRtl={properties.isRtl}
        />
      </Element>
      { bottomBlock(properties) }
    </div>
  ));

export default MessageSection;
